import * as React from "react";
const SvgSimulationAdd20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8.491 3.164A7 7 0 0 1 17 10h2A9.001 9.001 0 0 0 2.414 5.157 9 9 0 0 0 10 19v-2A7 7 0 0 1 8.491 3.165ZM7.3 5.234l1.515.909 5 3 1.429.857-1.43.857-5 3-1.514.91V5.233Zm2 6L11.356 10 9.3 8.766v2.468ZM17 12v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgSimulationAdd20Px;
